export default __webpack_public_path__ + "static/qr-bot-71a2a3b051f9ec68843b1559ec2022d2.svg";